/**
 * @description 投保對象用
 */
export enum InsureSubject {
  /** 幫自己或未滿 7 歲子女投保 */
  Self = '1',
  /** 幫配偶或 7 歲以上親屬投保 */
  Relatives = '2',
  /** 幫自己、配偶、子女、親屬、同行者投保 */
  All = '3'
}
